module.exports = __webpack_public_path__ + "img/VIDEO.9c6c4a1a.svg";